import { render } from "./TyrpInfo.vue?vue&type=template&id=d2fae070&scoped=true"
import script from "./TyrpInfo.vue?vue&type=script&lang=js"
export * from "./TyrpInfo.vue?vue&type=script&lang=js"

import "./TyrpInfo.vue?vue&type=style&index=0&id=d2fae070&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2fae070"]])

export default __exports__